const defaultState = {
  password_reset_details: {
    email: "",
    emailCode: false,
    resetPassword: null,
    signUp: false
  }
};

const signinReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_EMAIL_DETAILS": {
      return {
        ...state,
        password_reset_details: action.data
      };
    }
    default:
      return state;
  }
};

export default signinReducer;
